import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ShrinkSvg = function ShrinkSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("g", {
      fill: "#000",
      clipPath: "url(#shrink__a)",
      children: /*#__PURE__*/_jsx("path", {
        d: "m16.31 8.75 6.72-6.72L21.97.968l-6.72 6.72v-6.19h-1.5v8.75h8.75v-1.5zM1.5 13.75h8.75v8.75h-1.5v-6.19l-6.72 6.72-1.06-1.061 6.72-6.72H1.5zM8.75 7.688V1.5h1.5v8.75H1.5v-1.5h6.19L.97 2.03 2.03.97zM13.75 13.75h8.75v1.5h-6.19l6.72 6.719-1.06 1.06-6.72-6.72v6.19h-1.5z"
      })
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "shrink__a",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      })
    })]
  });
};
export var Shrink = function Shrink(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: ShrinkSvg
  }));
};